var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 60 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M45.944 16.5c0 8.806-7.138 15.944-15.944 15.944S14.056 25.306 14.056 16.5 21.194.556 30 .556 45.944 7.694 45.944 16.5M.867 55.983C5.973 44.454 17.406 37.002 29.996 37c12.59.002 24.022 7.454 29.128 18.983a10.19 10.19 0 0 1-.037 8.314 10.44 10.44 0 0 1-6.373 5.644 75.5 75.5 0 0 1-22.718 3.503 75.5 75.5 0 0 1-22.719-3.503 10.45 10.45 0 0 1-6.373-5.644 10.19 10.19 0 0 1-.037-8.314M29.996 37H30h-.009z",
    clipRule: "evenodd"
  })));
};
export default SvgUserIcon;